export default __webpack_public_path__ + "static/media/176.93630211.svg";